import React from 'react';
import Grid from '@material-ui/core/Grid';

export default function QuickViewWrapper({ children, ...props }) {
  return (
    <Grid container justify='center' alignItems='center'>
      <Grid item xs={11} sm={10} md={11}>
        {children}
      </Grid>
    </Grid>
  );
}
